
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChatMessage, MessageType } from "@/components/chat/ChatMessage";
import { TypingIndicator } from "@/components/chat/TypingIndicator";
import { RefObject } from "react";

interface MessageAreaProps {
  messages: MessageType[];
  isLoading: boolean;
  isConnected: boolean;
  searchQuery: string;
  messagesEndRef: RefObject<HTMLDivElement>;
}

export function MessageArea({ 
  messages, 
  isLoading, 
  isConnected, 
  searchQuery,
  messagesEndRef 
}: MessageAreaProps) {
  // Filter messages based on search query
  const filteredMessages = messages.filter(message =>
    searchQuery === "" || 
    message.content.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="flex-1 relative overflow-hidden">
      <ScrollArea className="h-full">
        <div className="p-6 space-y-6">
          {!isConnected && (
            <div className="text-center text-muted-foreground py-12">
              <div className="animate-pulse">
                <p className="text-lg">Connecting to agent...</p>
                <p className="text-sm mt-2">Please wait while we establish the connection</p>
              </div>
            </div>
          )}
          
          {isConnected && filteredMessages.length === 0 && searchQuery === "" && (
            <div className="text-center text-muted-foreground py-12">
              <div className="max-w-md mx-auto space-y-4">
                <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto">
                  <span className="text-2xl">👋</span>
                </div>
                <div>
                  <h3 className="text-xl font-medium mb-2">Welcome to AI Agent Chat</h3>
                  <p className="text-sm">
                    I'm here to help you with any questions or tasks. Send a message to get started!
                  </p>
                </div>
              </div>
            </div>
          )}

          {searchQuery && filteredMessages.length === 0 && (
            <div className="text-center text-muted-foreground py-12">
              <p>No messages found matching "{searchQuery}"</p>
            </div>
          )}
          
          {filteredMessages.map((message) => (
            <div key={message.id} className="animate-fade-in">
              <ChatMessage message={message} />
            </div>
          ))}
          
          {isLoading && <TypingIndicator />}
          <div ref={messagesEndRef} />
        </div>
      </ScrollArea>
    </div>
  );
}
